<template>
    <div>
        <h2 class="mb-8">{{ __('general.opening_hours') }}</h2>

        <form>
            <div>
                <table class="table table-striped">
                    <tr v-for="(day) in [1,2,3,4,5,6,7]">
                        <td class="align-middle">{{ dayNames[day] }}</td>
                        <td>
                            <button type="button" class="btn btn-secondary" v-show="days(day).length === 0">
                                {{ __('opening-hours.closed') }}
                            </button>

                            <periods :periods="days(day)" :day="day" @delete="deletePeriod" @update="updatePeriod">
                            </periods>

                            <button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#add_modal"
                                    @click="addModal(day)" v-show="days(day).length < 2">
                                <i class="fas fa-plus p-0"></i>
                            </button>
                        </td>
                    </tr>
                </table>

                <div v-for="(period, n) in form.opening_hours">
                    <input type="hidden" :name="'opening_hours['+n+'][open]'" :value="period.open">
                    <input type="hidden" :name="'opening_hours['+n+'][day]'" :value="period.day">
                    <input type="hidden" :name="'opening_hours['+n+'][close]'" :value="period.close">
                </div>

                <div class="modal fade" id="add_modal" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h2 class="m-0">{{ __('opening-hours.add') }}</h2>
                            </div>
                            <div class="modal-body">
                                <div class="row mb-3 align-items-center">
                                    <div class="col-4 text-right">
                                        {{ __('actions.open') }}
                                    </div>
                                    <div class="col-6">
                                        <input v-model="newOpen" type="time"
                                               class="timerange__open form-control"
                                               size="10">
                                    </div>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col-4 text-right">
                                        {{ __('actions.close') }}
                                    </div>
                                    <div class="col-6">
                                        <input v-model="newClose" type="time"
                                               class="timerange__open form-control" size="10">
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12" v-show="errors.length">
                                        <ul style="list-style: none;" class="text-danger text-center">
                                            <li v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" data-dismiss="modal"
                                        @click="addPeriod" v-show="errors.length === 0">
                                    <i class="fas fa-plus"></i> {{ __('actions.submit') }}
                                </button>
                                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                                    <i class="fas fa-times"></i> {{ __('actions.abort') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-start">
                <button id="submit-store-creation-button"
                        class="btn btn-primary"
                        @click.prevent="submitForm"
                        :disabled="form.processing">
                    <span class="svg-icon svg-icon-md"><i
                        class="text-white fas fa-save"></i></span>{{ __('actions.submit') }}
                </button>
            </div>
        </form>

        <div>
            <store-vacations :vacations="vacations" :store-uuid="storeUuid" />
        </div>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import Periods from '@components/OpeningHours/Periods.vue'
import StoreVacations from '@components/Store/StoreVacations.vue'

export default {
    layout: Navigation,

    name: 'EditOpeningHours',

    components: {StoreVacations, Periods},

    props: {
        store: Object,
        vacations: Array,
        storeUuid: String,
        dayNames: Object,
    },

    data() {
        return {
            periods: this.store.attributes.opening_hours,
            newOpen: '',
            newClose: '',
            newDay: 0,
            currentPeriods: [],
            form: this.$inertia.form({
                opening_hours: [],
            }),
        }
    },

    mounted() {
        this.form.opening_hours = this.polyfillMapPeriods(this.periods)
    },

    computed: {
        errors() {
            let errors = []

            this.currentPeriods.forEach((period, key) => {
                if (period.close.time && period.close.time >= this.newOpen) {
                    errors.push(this.__('opening-hours.warnings.overlap'))
                }
                if (this.newClose <= this.newOpen) {
                    errors.push(this.__('opening-hours.warnings.close_after_open'))
                }
            })

            return errors
        },
    },

    methods: {
        submitForm() {
            this.form.post(this.$route('store.opening-hours.update', this.storeUuid), {
                preserveScroll: false,
                preserveState: true,
            })
        },
        polyfillMapPeriods(input) {
            let periods = []
            for (let period of input) {
                periods.push({
                    day: period.open.day,
                    open: period.open.time,
                    close: period.close.time,
                })
            }
            return periods
        },

        days(day) {
            return this.form.opening_hours.filter(period => {
                return period.day === day
            })
        },

        addModal(day) {
            this.newDay = day
            this.currentPeriods = this.days(day)
        },

        addPeriod() {
            this.form.opening_hours.push({
                day: this.newDay,
                open: this.newOpen,
                close: this.newClose,
            })
        },

        deletePeriod(day, open) {
            this.form.opening_hours.forEach((period, key) => {
                if (period.day === (day)) {
                    if (period.open === open) {
                        this.$delete(this.form.opening_hours, key)
                    }
                }
            })
        },

        updatePeriod(day, open, close, newOpen, newClose) {
            this.form.opening_hours.forEach((period, key) => {
                if (period.day === (day)) {
                    if (period.open === open && period.close === close) {
                        this.form.opening_hours[key].open = newOpen
                        this.form.opening_hours[key].close = newClose
                    }
                }
            })
        },
    },
}
</script>
